import { useNavigate } from "react-router-dom";
import ConversionBlock from "@/components/landing/ConversionBlock";
import "@/styles/landing.css";
import { LegalFooter } from "@/components/LegalFooter";

// Interne, isolierte Vorschau-Route für die Abschlussseite (ConversionBlock).
// Rendert NUR den Block – ohne den Demo-Flow. Nicht in Navigation/SEO verlinkt.
export default function AbschlussVorschau() {
  const navigate = useNavigate();
  return (
    <div className="lp2-root" id="top" data-testid="abschluss-vorschau-page">
      <main>
        <ConversionBlock
          onTest={() => navigate("/unternehmer/login")}
          onRetry={() => navigate("/")}
        />
      </main>
      {/* ABO-RECHT-02, Betreiberfreigabe 27.10.2026 — Rechtslinks klein unten. */}
      <LegalFooter className="px-6 py-6" />
    </div>
  );
}
